import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import {
  CATALOG_AUTHOR_LIST_SET_DATA,
  CATALOG_AUTHOR_LIST_RESET_DATA,
} from 'rebook/apps/catalog/constants';


export const fetchInitialData = (match, location = {}) => {
  return async(dispatch, getState) => {
    const { ssr, authorList: currentState } = getState();
    const orderBy = get(ssr, 'query.o', 'weight');
    const pageNumber = ssr.query && ssr.query.page
      ? parseInt(ssr.query.page, 10)
      : 1;
    let newState = {
      pageNumber,
      orderBy,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }

    if (currentState) {
      newState = {
        ...newState,
        ...currentState,
      };
    }
    if (!get(newState, 'list', null)) {
      await dispatch(fetchAuthorList({ pageNumber, orderBy }));
    }
  };
};

export const fetchAuthorList = (params = {}) => {
  return async(dispatch, getState) => {
    const { ssr, authorList } = getState();
    const mergedState = { ...authorList, ...params };
    const { paginateBy, orderBy, pageNumber } = mergedState;
    let queryParams = {
      offset: (pageNumber - 1) * paginateBy,
      limit: paginateBy,
      o: orderBy,
    };

    dispatch(setData({
      list: null,
      totalAuthorsCount: null,
    }));

    const qs = queryString.stringify(queryParams);
    const url = `/api/authors/?${qs}`;

    return await (
      fetchQuery(url, { headers: ssr.headers })
        .then(({ data }) => {
          const lastPageNumber = Math.ceil(data.meta.total_count / paginateBy);
          dispatch(setData({
            list: data.objects,
            totalAuthorsCount: data.meta.total_count,
            pageNumber,
            orderBy,
            lastPageNumber,
          }));
        })
        .catch(({ data, resp, error }) => {
          Raven.captureMessage('failed to load author list data due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
        })
    );
  };
};

export const setData = (payload) => {
  return (dispatch) => {
    dispatch({
      type: CATALOG_AUTHOR_LIST_SET_DATA,
      payload,
    });
  };
};

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: CATALOG_AUTHOR_LIST_RESET_DATA,
    });
  };
};
